export default __webpack_public_path__ + "static/media/icon-engine-default.79895ae7.svg";